import jwtDecode from 'jwt-decode';
import UserProfileClient from '../lib/apiClients/roofSnapApiClient/userProfileClient';
import { CALL_API } from "../middleware/api";
import LocalStorageWrapper from "../lib/localStorageWrapper";
import {
    GET_CURRENT_USER_REQUEST,
    GET_CURRENT_USER_SUCCESS,
    GET_CURRENT_USER_FAILURE,
} from './actionTypes';

export const getCurrentUser = () => {
    const accessToken = LocalStorageWrapper.getItem('accessToken');

    if (!accessToken) {
        return {
            type: GET_CURRENT_USER_FAILURE,
        }
    }

    const tokenPayload = jwtDecode(accessToken);
    const userId = parseInt(tokenPayload.name, 10);

    const userProfileClient = new UserProfileClient('v1');
    const request = userProfileClient.getUserProfile;

    return {
        [CALL_API]: {
            types: [
                GET_CURRENT_USER_REQUEST,
                GET_CURRENT_USER_SUCCESS,
                GET_CURRENT_USER_FAILURE
            ],
            request,
            params: {
                id: userId,
            },
        }
    };
};
